module.exports = __webpack_public_path__ + "42399e6e3f04ddd868928371dbb83154.jpg";